export const RICH_TEXT_BLOCK_PREFIX = "RichTextBlock";

export const RICH_TEXT_BLOCK_CLASSES = {
  richText: `${RICH_TEXT_BLOCK_PREFIX}-richText`,
};
